import { TypedCacheBucket, TypedCacheEntry } from '../models/state.models';

export function asTypedCacheBucket<T>(cache: TypedCacheBucket<T> | undefined): TypedCacheEntry<T>[] {
  return cache ?? [];
}

export function findCacheEntry<T>(cache: TypedCacheBucket<T>, type: string): TypedCacheEntry<T> | undefined {
  return asTypedCacheBucket(cache).find(entry => entry.type === type);
}

export function upsertCacheEntry<T>(cache: TypedCacheBucket<T>, type: string, response: T, replaceExisting: boolean): TypedCacheEntry<T>[] {
  const bucket = [...asTypedCacheBucket(cache)];
  const index = bucket.findIndex(entry => entry.type === type);

  if (replaceExisting && index !== -1) {
    bucket.splice(index, 1);
  }

  bucket.push({ type, response });
  return bucket;
}
